import { z } from 'my-zod'

export const outfitterCustomerDataModel = z.object({
  outfitterGroupId: z.number(),
  customerId: z.string(),
  notes: z.string().max(500),
  highRiskCustomer: z.boolean()
})

export type outfitterCustomerDataModel = z.infer<typeof outfitterCustomerDataModel>
